import { defineComponent, ref, shallowRef, watch } from '@vue/composition-api';
import DetailDiff from './detailDiff.vue';
import { delay, pick } from 'lodash';
export const DetailDiffPro = defineComponent({
    name: 'DetailDiffPro',
    emits: ['change'],
    props: {
        preTitle: {
            type: String,
            default: '',
        },
        nextTitle: {
            type: String,
            default: '',
        },
        hideHeader: {
            type: Boolean,
            default: false,
        },
        originalData: {
            type: [String, Object, Array, null],
            require: true,
            default() {
                return '';
            },
        },
        modifiedData: {
            type: [String, Object, Array, null],
            require: true,
            default() {
                return '';
            },
        },
        type: {
            type: String,
            default() {
                return 'json';
            },
        },
        readOnly: {
            type: Boolean,
            default() {
                return false;
            },
        },
        options: {
            type: Object,
            default: () => { },
        },
    },
    setup(props) {
        const data = shallowRef({});
        const backData = shallowRef({});
        let curBack = false;
        const renderBack = ref(curBack);
        watch(() => pick(props, 'originalData', 'modifiedData'), (cur) => {
            if (curBack) {
                data.value = cur;
            }
            else {
                backData.value = cur;
            }
            // 保存最新指针,用于判断更新那个data
            curBack = !curBack;
            // 延迟切换 避免滚动到diff节点闪烁
            delay(() => {
                renderBack.value = !renderBack.value;
            }, 100);
        }, { immediate: true });
        return { data, backData, renderBack };
    },
    render() {
        if (!this.readOnly) {
            return (<div class="h-full">
          <DetailDiff preTitle={this.preTitle} nextTitle={this.nextTitle} hideHeader={this.hideHeader} originalData={this.originalData} modifiedData={this.modifiedData} type={this.type} readOnly={false} options={this.options} onChange={(value) => this.$emit('change', value)}/>
        </div>);
        }
        return (<div class="h-full">
        <DetailDiff style={{ display: this.renderBack ? 'none' : 'block' }} preTitle={this.preTitle} nextTitle={this.nextTitle} hideHeader={this.hideHeader} originalData={this.data.originalData} modifiedData={this.data.modifiedData} type={this.type} readOnly={this.readOnly} options={this.options} onChange={(value) => this.$emit('change', value)}/>
        <DetailDiff style={{ display: this.renderBack ? 'block' : 'none' }} preTitle={this.preTitle} nextTitle={this.nextTitle} hideHeader={this.hideHeader} originalData={this.backData.originalData} modifiedData={this.backData.modifiedData} type={this.type} readOnly={this.readOnly} options={this.options} onChange={(value) => this.$emit('change', value)}/>
      </div>);
    },
});
